import CategoryEditor from "components/CategoryEditor";
import React from "react";
import { createRoot } from "react-dom/client";

export default function initCategoryEditor(selector, categoriesId) {
  const elem = document.querySelector(selector);
  if (!elem || !categoriesId) {
    return;
  }

  createRoot(elem).render(<CategoryEditor categoriesId={categoriesId} />);
}
